module.exports = __webpack_public_path__ + "img/changeColor-1@2x.310bcd2.webp";